/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:16:23
 */
export default {
  lang: "英语",
  landing: {
    name1: "Ouvrez Carlcare",
    name2: "Faire une réservation",
    name3: "Avec Carlcare, vous pouvez vérifier votre commande à tout moment.",
    name4: "",
    name5: "Faites glisser vers la droite",
    name6: "Vérification terminée",
        name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02150880282.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
        name40: "Exclusive for",
    name41: "Jakarta Pusat!",
    name42: "Reservation Now",
    name43: "What is Carlcare Home Service ?",
    name44: "1.Carlcare Home Service is available for TECNO, Infinix, and itel users.",
    name45: "2.Enjoy convenient and efficient repair services anywhere (at home, in the office, at a café, on campus, or outdoors), saving you time and effort.",
    name46: "Why do we recommend choosing Carlcare Home Service ?",
    name47: "Free Home Service Charges",
    name48: "No home service fees required.",
    name49: "*For out of warranty or accidental damage, pay for parts and labor.",
    name50: "Easy Booking",
    name51: "Easily book through Carlcare App, website, hotline, or WhatsApp.",
    name52: "Safe & Reliable",
    name53: "With strict safety measures, ensuring your device is in trusted hands.",
    name54: "Official Support",
    name55: "All repairs by Carlcare official engineers use only original spareparts.",
    name56: "Ways to Book Carlcare Home Service",
    name57: "1. Open the Carlcare App",
    name58: '2. Tap "Reservation"',
    name59: '3. Choose "Carlcare Home Service"',
    name60: "4. Select your current location",
    name61: "5. Fill in the required details to complete the reservation",
    name62: "1. Open the Carlcare Official Website:https://www.carlcare.com/id/",
    name63: '2. Tap "Perbaiki Telepon"',
    name64: '3. Choose "Carlcare Home Service"',
    name65: "4. Select your current location",
    name66: "5. Fill in the required details to complete the reservation",
    name67: "Call Carlcare hotline: 021 5088 0282 to book Carlcare Home Service.",
    name68: "Contact Carlcare WhatsApp Business Account:+62-812-9009-0559 to Carlcare Home Service.",
    name69: "1.Device needs repair.",
    name70: "2.Book Carlcare Home Service.",
    name71: "3.Engineer contacts you to confirm the appointment time.",
    name72: "4.Engineer arrives at the scheduled time.",
    name73: "5.Complete the repair and make the payment.",
    name74: "Statement:",
    name75: "1.Free Home Service applies to service fees only. ",
    name76: "①Under Warranty: Enjoy free home service and repairs;",
    name77: "②Out of Warranty:Only pay for labor and spareparts,no extra home service charges.",
    name78: "2.Carlcare Home Service is currently limited to the the Jakarta Pusat and will gradually expand to more regions in the future. Please Stay tuned!",
    name79: "3.The final explanation of the activity belongs to Carlcare.",
    name80: "App",
    name81: "Website",
    name82: "Hotline",
    name83: "WhatsApp",
    name84: "No door-to-door fee",
    name85: "Service Process:",
    name86: "Book Carlcare",
    name87: "Home Service",
    name88: " Today!",
  },
  order: {
    name1: "Choisissez le modèle de l\’appareil",
    name2: "Description de défaut:",
    name3: "Appuyez pour sélectionner le magasin de services",
    name4: "Magasin de services:",
    name5: "Heure de réservation:",
    name6: "Veuillez décrire le problème de votre appareil en détail!",
    name7: "Appuyez pour sélectionner l\’heure d’arrivée",
    name8: "Veuillez saisir vos coordonnées correctes afin que nous puissions vous joindre",
    name9: "Le temps de réservation disponible est le suivant",
    name10: "Veuillez entrer votre numéro de téléphone",
    name11: "Prix",
    name12: "Informations personnelles:",
    name13: "Veuillez entrer votre nom",
    name14: "Soumettre",
    name15: "Annuler",
    name16: "OK",
  },
  shops: {
    name1: "Basé sur la marque que vous choisissez, les magasins suivants peuvent vous servir!",
    name2: "Bientôt dans d'autres magasins de détail! Restez avec nous!",
  },
  price: {
    name1: "Marque",
    name2: "Modèle",
    name3: "Article",
    name4: "Prix",
    name5: "Rappel amical:",
    name6: "Ces prix sont juste à titre de référence, et le prix réel dépend de l\’état de votre appareil.",
    name7: "S\’il n\’y a pas de symbole spécial, l\’unité de prix est l\’unité monétaire locale.",
    name8: "Désolé! Aucune information sur les prix disponible dans la région actuelle.",
    name11:"Coût de la main-d\'œuvre",
    name12:"Prix total",
    name13: "5. Si le coût de la main-d\'œuvre est \"/\", cela signifie que le coût de la main-d\'œuvre doit être consulté avec le magasin.",
    item_main_board: "Carte mère",
    item_screen_frame: "Écran (cadre)",
    item_screen_screen_frame: "Écran secondaire (Cadre)",
    item_touch_screen: "Écran tactile",
    item_camera: "Appareil photo",
    item_fixed_focus_camera: "Appareil photo à mise au point fixe",
    item_auto_focus_camera: "Appareil photo à mise au point automatique",
    item_screen: "Écran",
    item_secondary_screen: "Écran secondaire",
    item_fingerprint_module: "Module d\\'empreintes digitales",
    item_speaker: "\"Haut-parleur\"",
    item_receiver: "\"Récepteur\"",
    item_small_board: "Petit tableau",
    item_battery_cover: "Couvercle de la batterie",
    item_battery: "Batterie",
    item_charger: "Chargeur",
    item_usb_cable: "Câble USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Pas de données",
    name2: "Fournisseur de service:",
    name3: "Marque de service:",
    name4: "Téléphone:",
    name5: "Quantité de la commande:",
    name6: "Évaluation du service",
    name7: "Environnement de service:",
    name8: "Attitude de service:",
    name9: "Efficacité du service:",
    name10: "Qualité du service:",
    name11: "Évaluation du client",
    name12:"à",
    name13:"Désactivé",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Ouvrez Carlcare",
    name1: "Veuillez faire une capture d’écran des informations de réservation et les enregistrer en tant que reçu pour accéder au service prioritaire.",
    name2: "Soumis avec succès",
    name3: "1. Nettoyer les données",
    name4: "Veuillez sauvegarder à l\’avance les données privées importantes sur votre téléphone",
    name5: "2. Désactivez le mot de passe de mise sous tension",
    name6: "Avant d’aller au magasin de services, veuiller:",
    name7: "Magasin de services:",
    name8: "Heure de réservation:",
    name9: "Description de défaut:",
    name10: "Modèle de l\’appareil:",
    name11: "Numéro de commande:",
    name12: "Informations de la commande",
  },
  title: {

    name1: "Prend en charge les pays suivants:",
    name2: "Choisissez le modèle",
    name3: "Réservation",
    name4: "Détails du magasin de services",
    name5: "Sélectionnez le magasin de service",
  },
  error: {
    
    name1: "Aucune donnée. Veuillez vérifier vos informations de réparation",
    name2: "Besoin de plus d'aide? Contactez-nous.",
    name3: "Désolé, il n\’y a pas de centre Carlcare dans cette région.",
    name4: "Veuillez d\’abord choisir un centre de service",
    name5: "Échec.",
    name6: "Veuillez d\’abord choisir le modèle d\’appareil",
    name7: "Détails",
    name8: "Veuillez décrire vos besoins en détail",
    name9: "",
  },
  add1:{
    "name0": "fr",
    "name1": "Votre commande a été confirmée. Nous nous réjouissons de votre arrivée.",
    "name2": "Sélectionner une ville",
    "name3": "Veuillez saisir un numéro de téléphone de %1$s chiffres.",
    "name4": "Heures d\\'ouverture en semaine",
    "name5": "Lundi",
    "name6": "Mardi",
    "name7": "Mercredi",
    "name8": "Jeudi",
    "name9": "Vendredi",
    "name10": "Samedi",
    "name11": "Dimanche",
    "name12": "Entrez le pays et faites la recherche"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Pick-up Time",
    "name7": "Tap to select pick-up time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "Autres",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  "name58": "Nettoyage gratuit/Mise à jour gratuite du système",
  coupons: {
    name1:"Coupons",
    name2:"Appuyez pour rediriger",
    name3:"Ouvrez l\'application Carlcare pour évaluer la commande",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Sélectionner un service",
    name7:"Nettoyage gratuit",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "Informations incorrectes",
    "cancelReason1": "Impossible d\\'arriver à l\\'heure",
    "cancelReason2": "Dupliquer la commande/pas ma commande",
    "cancelReason3": "L\\’échec ne se reproduit pas",
    "cancelReason4": "Juste pour le test/ enquête/événement/…",
    "cancelReason5": "Prix élevé",
    "cancelReason6": "Manque de matériel",
    "cancelReason7": "Pas de services différenciés",
    "cancelReason8": "Le magasin est trop loin",
    "cancelReason9": "Le magasin est fermé",
    "cancelReason10": "Mauvaise attitude de service",
    "cancelReason11": "Remplacement/réparation pour d\\’autres marques",
    "cancelReason12": "Impossible de trouver le magasin",
    "cancelReason13": "Autre",
    "cancelOrder": "Annuler la commmande",
    "reason_dialog_title": "Veuillez nous dire la raison de l\\’annulation",
    "Cancel": "Annuler",
    "OK": "OK",
    "name1": "Entrez le code de vérification",
    "name2": "Code de vérification invalide",
    "repair_reservation_detail_canceled": "Cette commande a été annulée!",
    "purchase_cancel_dialog_content": "Confirmez-vous l\\'annulation de la commande?",
    "yes": "Oui",
    "no": "Non"
}
};
